module.exports = __webpack_public_path__ + "static/media/product_flood_extent.a609e070.png";